module.exports = __webpack_public_path__ + "img/cz-select.a4b70c53.svg";